import { CloseOutlined } from '@ant-design/icons'
import { nanoid, unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  ModalProps,
  notification,
  Radio,
  Row,
  Select,
  Upload,
} from 'antd'
import _ from 'lodash'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { Checks } from '../../../../models/setting'
import { getRecipeNormalFrequencyName, SPLBCategoryCategories } from '../../../../models/warehouseSetup'
interface AutoExpenseModalProps {
  pageList?: any[]
  visible?: boolean
  title?: string
  editDetailMessage?: any
  onOk?: () => void
  onCancel?: () => void
  onSuccess?: (m?: any, v?: any) => void
}
export const AddOrEditModal = ({
  pageList,
  title,
  editDetailMessage,
  onCancel,
  onOk,
  onSuccess,
  ...others
}: AutoExpenseModalProps & ModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const { Option } = Select

  const [form] = Form.useForm()

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (others?.visible) {
      if (title == 'edit') {
        form.setFieldsValue({
          ...editDetailMessage
        })
      }
    } else {
      form.resetFields()
    }
  }, [others?.visible])

  return (
    <>
      <Modal
        {...others}
        title={'库存默认下限值' + (title == 'create' ? '添加' : '编辑')}
        width={500}
        confirmLoading={isLoading}
        cancelText='取消'
        okText='确定'
        onCancel={() => {
          onCancel && onCancel()
          form.resetFields()
        }}
        destroyOnClose
        onOk={(e) => {
          form.validateFields().then((values) => {
            setIsLoading(true)
            const params = {
              ...values,
            }
            if (title == 'create') {
              const sameName = pageList?.find((v: any) => v.merchandiseCategories == params.merchandiseCategories)
              if (sameName) {
                notification.error({
                  message: '商品类别已存在',
                })
                setIsLoading(false)
                return
              }
            } else if (title == 'edit') {
              // 编辑时排除自己这条记录，再检查是否有同名类别
              const list = pageList?.filter((v: any) => v.merchandiseCategories !== editDetailMessage?.merchandiseCategories)
              const sameName = list?.find((v: any) => v.merchandiseCategories === values.merchandiseCategories)
              if (sameName) {
                notification.error({
                  message: '商品类别已存在',
                })
                setIsLoading(false)
                return
              }
            }
            onSuccess && onSuccess(params)
            setIsLoading(false)
          })
        }}
      >
        <Form
          form={form}
          autoComplete='off'
          colon={false}
          labelAlign='right'
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                label='商品类别'
                name='merchandiseCategories'
                rules={[{ required: true, message: '请选择' }]}
              >
                <Select placeholder='请选择商品类别'>
                  {SPLBCategoryCategories.map((v: any) => {
                    return (
                      <Option value={v} key={v}>
                        {getRecipeNormalFrequencyName(v)}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label='默认值'
                name='windowsDefault'
                rules={[
                  { required: true, message: '请输入' },
                  {
                    pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,2})?$/),
                    message: '请输入最多带两位小数的数值',
                  },]}
              >
                <Input type='number' placeholder='请输入默认值' />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  )
}
